import { render, staticRenderFns } from "./brandCategoryList.vue?vue&type=template&id=57ac8adf&scoped=true"
import script from "./brandCategoryList.vue?vue&type=script&lang=js"
export * from "./brandCategoryList.vue?vue&type=script&lang=js"
import style0 from "./brandCategoryList.vue?vue&type=style&index=0&id=57ac8adf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac8adf",
  null
  
)

export default component.exports